"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumObject = exports.isEnumObject = void 0;
const shallow_equal_object_1 = require("shallow-equal-object");
exports.isEnumObject = (v) => {
    return v instanceof EnumObject;
};
class EnumObject {
    // eslint-disable-next-line no-unused-vars
    constructor(enumObject) {
        this._value = enumObject;
    }
    get is() {
        return typeof this._value !== "undefined";
    }
    get deleted() {
        return this._value === null;
    }
    get value() {
        return this._value;
    }
    toString() {
        return String(this._value);
    }
    equals(enumObject) {
        if (enumObject === null || enumObject === undefined) {
            return false;
        }
        if (enumObject._value === undefined) {
            return false;
        }
        return shallow_equal_object_1.shallowEqual(this._value, enumObject._value);
    }
    equalsDTO(val) {
        if (val === null || val === undefined) {
            return false;
        }
        return this._value === val;
    }
    static includes(enums, value) {
        for (const label of enums) {
            if (label.equalsDTO(value))
                return true;
        }
        return false;
    }
    static isEnum(enumClass, value) {
        const values = enumClass.V;
        return Object.values(values).includes(value);
    }
}
exports.EnumObject = EnumObject;
EnumObject.V = {};
//# sourceMappingURL=EnumObject.js.map